const STORAGE_PREFIX = 'chatbot-admin-draft:';

function storageKey(domainName, botName) {
  return `${STORAGE_PREFIX}${domainName}:${botName}`;
}

export function loadAdminDraft(domainName, botName) {
  if (typeof localStorage === 'undefined') {
    return null;
  }

  const key = storageKey(domainName, botName);

  try {
    const raw = localStorage.getItem(key);
    if (!raw) {
      return null;
    }

    const data = JSON.parse(raw);
    if (!data || typeof data !== 'object' || !data.payload || typeof data.payload !== 'object') {
      localStorage.removeItem(key);
      return null;
    }

    return data;
  } catch {
    localStorage.removeItem(key);
    return null;
  }
}

export function saveAdminDraft(domainName, botName, { payload }) {
  if (typeof localStorage === 'undefined') {
    return;
  }

  const entry = {
    payload,
    savedAt: new Date().toISOString(),
  };

  localStorage.setItem(storageKey(domainName, botName), JSON.stringify(entry));
}

export function clearAdminDraft(domainName, botName) {
  if (typeof localStorage === 'undefined') {
    return;
  }

  localStorage.removeItem(storageKey(domainName, botName));
}
